import { BASE_URL } from "@constants/api.constants";
import { uploadImageFile } from "@utils/upload.util";

export const getInventoryCategoryInputs = (initialValues) => [
  {
    groupName: "Category",
    type: "TEXT",
    label: "Category Name",
    id: "name",
    name: "name",
    value: initialValues?.name || "",
    placeholder: "Enter the Category Name",
    validations: [
      {
        type: "REQUIRED",
        message: "Category Name is required !",
      },
    ],
  },
    {
      groupName: "Category",
      type: "FILE_UPLOAD",
      label: "Category Image",
      id: "image",
      name: "image",
      value: initialValues?.image || "",
      filePrefix: BASE_URL + "app-source/images/",
      handleSelfUpload: uploadImageFile,
      validations: [],
    },
    {
      groupName: "Category",
      type: "TEXT",
      label: "Unique ID",
      id: "unique_id",
      name: "unique_id",
      value: initialValues?.unique_id || "",
      placeholder: "Enter the Unique ID",
      validations: [],
    },
  {
    groupName: "Category",
    type: "SELECT",
    label: "Status",
    id: "status",
    name: "status",
    options: [
      { name: "Enable", value: "1" },
      { name: "Disable", value: "2" },
    ],
    value: initialValues?.status || "1",
    placeholder: "Select status",
  },
  {
    groupName: "Specifications",
    // groupClass: "col-md-12",
    type: "FORM_REPEATER",
    validations: [],
    name: "repeater",
    value: initialValues?.repeater || null,
    inputs: [
      {
        type: "TEXT",
        label: "Sort Order",
        id: "sort_order",
        name: "sort_order",
        placeholder: "Enter the Sort Order",
        size: 2,
      },
      {
        type: "TEXT",
        label: "Specification",
        id: "specification",
        name: "specification",
        placeholder: "Enter the Specification",
        size: 2,
      },
    ],
  },
];
